var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 35.9583,
    r: 29,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d0cfce",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m54.8295,55.7853c-5.2796-5.2522-6.8833-10.7914-6.8833-18.8269,0-8.0081,3.2459-15.2581,8.4939-20.5061"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d0cfce",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m15.5331,16.4522c5.248,5.248,8.4939,12.498,8.4939,20.5061,0,8.0287-2.409,14.4908-7.6808,19.7419"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0cfce",
    d: "m50.738,10.9985c4.8254,5.1792,7.7822,12.1224,7.7822,19.7596,0,16.0162-12.9837,29-29,29-5.3519,0-10.3612-1.4558-14.6646-3.9839,5.2892,5.6453,12.7977,9.1841,21.1444,9.1841,16.0162,0,29-12.9838,29-29,0-10.6313-5.7308-19.9113-14.262-24.9598Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 35.9583,
    r: 29,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m56.494,56.5182c-5.2796-5.2522-8.5478-12.5243-8.5478-20.5598,0-8.0081,3.2459-15.2581,8.4939-20.5061"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15.5331,15.4522c5.248,5.248,8.4939,12.498,8.4939,20.5061,0,8.0287-3.2455,15.2768-8.5172,20.5279"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "45.9462 35.4583 47.9462 36.4583 49.9462 35.4583"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "26.0271 36.4583 24.027 35.4583 22.027 36.4583"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "25.2025 43.3317 23.4241 41.9762 21.2726 42.5856"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "23.0012 49.4547 21.523 47.7769 19.2938 47.9528"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "19.5977 54.6466 18.8245 52.5484 16.6821 51.9081"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "20.2695 17.7956 18.1198 18.411 17.3222 20.4999"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "23.4875 23.5425 21.2891 23.6516 20.0026 25.5061"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "25.4746 29.7549 23.27 29.3806 21.6479 30.9197"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "46.7708 28.5842 48.5492 29.9397 50.7006 29.3303"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "48.972 22.4611 50.4502 24.1389 52.6794 23.9631"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "52.4993 17.1179 53.2724 19.216 55.4149 19.8564"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "51.5447 53.912 53.6945 53.2967 54.4921 51.2077"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "48.4822 48.4289 50.7156 48.3183 51.9671 46.4653"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "46.4986 42.161 48.7032 42.5352 50.3253 40.9962"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.ec70bb427889275b80e6f4bb002e8a69.svg";
export { ForwardRef as ReactComponent };